<template>
  <BaseView title="CII">
    <template #content>
      <v-container
        fill-height
        fluid
        class="screenBackground"
        style="
          max-height: 100%;
          max-width: 100%;
          overflow-y: auto;
          overflow-x: hidden;
          align-items: start;
          padding: 0%;
        "
      >
        <v-row
          style="height: 100%"
          no-gutters
        >
          <v-col
            cols="6"
            no-gutters
          >
            <div style="height: 50%; padding: 10px">
              <HistoricalCiiChart />
            </div>
            <div style="height: 50%; padding: 10px">
              <AverageCiiChart />
            </div>
          </v-col>
          <v-col
            cols="6"
            no-gutters
          >
            <div
              class="rounded-lg d-flex flex-column"
              style="height: 100%; padding: 10px"
            >
              <DataTable />
            </div>
          </v-col>
        </v-row>
      </v-container>
    </template>
  </BaseView>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import DataTable from "./DataTable.vue";
import HistoricalCiiChart from "./components/HistoricalCiiChart.vue";
import AverageCiiChart from "./components/AverageCiiChart.vue";
import BaseView from "../components/BaseView.vue";
export default {
  name: "CIISuccessViewLarge",
  components: {
    AverageCiiChart,
    DataTable,
    HistoricalCiiChart,
    BaseView,
  },
  data: function () {
    return {
      showErrorSnackBar: false,
      selectedChart: "cii",
    };
  },
  computed: {
    ...mapState("cii", ["ciiRatings", "ciiContributionValues", "ciiHistory"]),
    ...mapGetters("cii", [
      "ciiHistoryChartOptions",
      "ciiSeries",
      "ciiNoEffectSeries",
      "ciiNoFoulingSeries",
      "ciiNoWeatherSeries",
      "ciiAverageChartOptions",
    ]),
    ...mapGetters("cii/fouling", [
      "foulingAverageChartOptions",
      "foulingAverageSeriesData",
    ]),
  },
  methods: {
    ...mapActions("cii", ["fetchInitialData"]),
    ...mapActions("cii/fouling", ["fetchFoulingData"]),
    async _setUp(vesselName) {
      await this.fetchInitialData(vesselName);

      this.$store.commit(
        "cii/calculation/SET_CII_CALCULATION_INPUT_STATE",
        this.ciiContributionValues.toCalculationInputData()
      );

      await this.$store.dispatch(
        "cii/calculation/calculateCiiContribution",
        vesselName
      );
    },
  },
  watch: {
    async $route(next, previous) {
      const previousVesselName = previous.params.vessel;
      const nextVesselName = next.params.vessel;
      if (previousVesselName != nextVesselName) {
        await this._setUp(nextVesselName);
      }
    },
  },
  async mounted() {
    await this._setUp(this.$route.params.vessel);
  },
};
</script>
